import { getCrmTypes } from 'crms/utils';

const { isTat } = getCrmTypes();

export const BOOKING_OPERATOR_ID = isTat ? 487 : 9237;
